import { FC } from 'react';
import { ColorProps, Text } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import { RangeIntervalTypes } from 'features/Dashboard/pages/components/RangeIntervalPicker/utils';
import useIntervalContext from 'features/Dashboard/pages/hooks/useIntervalContext';

import locales from './locales';

export type AvailableLocales = Exclude<RangeIntervalTypes, 'custom'>;

export const DeltaIndicator: FC<{
  delta: number | null;
  color?: ColorProps['color'];
}> = ({ color, delta }) => {
  const { interval } = useIntervalContext();

  if (delta === null) {
    return null;
  }

  let indicatorText: string = locales.stable;
  const amount = formatAmount({
    forcePlusSign: false,
    isMinorUnitValue: true,
    value: Math.abs(delta),
  });
  const translationInterval =
    locales[interval.type as AvailableLocales] || locales.unknown;

  if (delta > 0) {
    indicatorText = locales.formatString(translationInterval.more, {
      amount,
    });
  }

  if (delta < 0) {
    indicatorText = locales.formatString(translationInterval.less, {
      amount,
    });
  }

  return (
    <Text
      color={color || undefined}
      fontSize="font-12"
      fontWeight="weight-400"
      variant="light"
      whiteSpace="nowrap"
    >
      {indicatorText}
    </Text>
  );
};
